import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DeviceAttachment, DeviceStatus } from '~status/models/device-status';

export const StatusActions = createActionGroup({
    source: 'Status',
    events: {
        'Load Device Status': props<{ deviceId: string; silent?: boolean }>(),
        'Load Device Status Success': props<{ data: DeviceStatus }>(),
        'Load Device Status Failure': props<{ error: string }>(),
        'Load Impersonation token': emptyProps(),
        'Load Impersonation token Success': props<{ email: string; token: string }>(),
        'Load Impersonation token Failure': props<{ error: string }>(),
        'Upload Attachment Success': props<{ deviceId: string; attachment: DeviceAttachment }>(),
        'Delete Attachment': props<{ deviceId: string; id: string }>(),
        'Delete Attachment Success': props<{ deviceId: string; id: string }>(),
        'Delete Attachment Failure': props<{ error: string }>(),
        'Set qrScanner status': props<{ isOpen: boolean }>(),
    },
});
